import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IGetGroupMembersParams,
  IGroupMember,
} from '@network/models/group-member.model'

export class GroupMembersApi {
  constructor(private axios: AxiosService) {}

  getGroupMembers = async (params?: IGetGroupMembersParams) => {
    const response = await this.axios.get<IPayload<IGroupMember[]>>(
      Endpoints.getGroupMembers,
      params,
    )
    return response
  }
}
